import { isStennTheme as r } from "./isStennTheme.mjs";
import { getKeys as n } from "./types3.mjs";
const i = {
  // biome-ignore lint/suspicious/noExplicitAny:
  get: function(o, t) {
    return !o[t] && t !== "@@toStringTag" && t !== "vars" && t !== "$$typeof" && t !== "mainChannel" && t !== "inherit" && typeof t == "string" ? (console.warn(
      `field ${t} doesn't exists in theme.pallete. Please, use another existing token from @stenngroup/theme`
    ), "") : typeof o[t] == "object" && o[t] !== null ? new Proxy(o[t], i) : o[t];
  }
}, f = (e) => {
  r(e) ? n(e).forEach((o) => {
    e[o].palette = new Proxy(
      e[o].palette,
      i
    );
  }) : e.palette = new Proxy(e.palette || {}, i);
};
export {
  f as addCompatibilityMode
};
//# sourceMappingURL=addCompatibilityMode.mjs.map
